import React from 'react';
import {observer} from 'mobx-react';
import {GenericModal} from '@techsee/techsee-ui-common/lib/modals/generic';
import Translate from '../../components/translate/Translate';
import {ClientTimeoutDialogController} from './ClientTimeoutDialog.controller';
import './ClientTimeoutDialog.style.scss';

interface ClientTimeoutDialogModalProps {
    ctrl: ClientTimeoutDialogController;
}

const Header = () => {
    return (
        <div className='client-timeout-dialog-header'>
            <h3 className='client-timeout-dialog-title'>
                <Translate text='CLIENT_TIMEOUT.VIEW.TITLE' />
            </h3>
        </div>
    );
};

const Content = () => {
    return (
        <div className='client-timeout-dialog-body'>
            <p>
                <Translate text='CLIENT_TIMEOUT.VIEW.BODY' />
            </p>
        </div>
    );
};

const Footer = ({ctrl}: ClientTimeoutDialogModalProps) => {
    return (
        <div className='client-timeout-dialog-footer'>
            <button className='btn btn-primary' onClick={() => ctrl.closeMessage()}>
                <Translate text='CLIENT_TIMEOUT.VIEW.OK' />
            </button>
        </div>
    );
};

@observer
export class ClientTimeoutDialogModal extends React.Component<ClientTimeoutDialogModalProps> {
    render() {
        const {ctrl} = this.props;

        return (
            <GenericModal
                className='modal-dialog client-timeout-dialog custom-timeout-styles'
                header={() => <Header />}
                content={() => <Content />}
                toolbar={() => <Footer ctrl={ctrl} />}
                show={ctrl.isVisible}
                onHideHandler={() => ctrl.closeMessage()}
            />
        );
    }
}
